module.exports = __webpack_public_path__ + "img/Accessoire.50b4c7b3.svg";